export enum QueryKey {
  AUTH_ME_GET = 'AUTH_ME_GET',
  GET_REGIONS = 'GET_REGIONS',
  GET_VACANCIES = 'GET_VACANCIES',
  GET_SCHEDULE_WORK = 'GET_SCHEDULE_WORK',
  GET_EMPLOYMENT_TYPES = 'GET_EMPLOYMENT_TYPES',
  GET_SKILLS = 'GET_SKILLS',
  GET_PAYMENT_PERIODS = 'GET_PAYMENT_PERIODS',
  GET_EDUCATION_LEVELS = 'GET_EDUCATION_LEVELS',
  GET_ECONOMIC_ACTIVITIES = 'GET_ECONOMIC_ACTIVITIES',
  GET_CURRENCIES = 'GET_CURRENCIES',
  GET_USERS = 'GET_USERS',
  GET_USER = 'GET_USER',
  GET_COMPANY = 'GET_COMPANY',
  GET_COMPANY_TYPES = 'GET_COMPANY_TYPES',
  GET_COMPANY_REVIEWS = 'GET_COMPANY_REVIEWS',
  GET_ACTIVITY_SPHERE = 'GET_ACTIVITY_SPHERE',
  GET_COMPANIES = 'GET_COMPANIES',
  GET_VACANCY = 'GET_VACANCY',
  GET_VACANCY_CANDIDATES = 'GET_VACANCY_CANDIDATES',
  GET_CANDIDATES = 'GET_CANDIDATES',
  GET_CANDIDATE = 'GET_CANDIDATE',
  GET_CANDIDATE_VACANCIES = 'GET_CANDIDATE_VACANCIES',
  GET_CANDIDATE_REVIEWS = 'GET_CANDIDATE_REVIEWS',
  GET_CANDIDATE_PROCESSES = 'GET_CANDIDATE_PROCESSES',
  GET_CANDIDATE_PROCESSES_REFRESH = 'GET_CANDIDATE_PROCESSES_REFRESH',
  GET_USERS_WITH_PAGINATION = 'GET_USERS_WITH_PAGINATION',
  GET_CANDIDATE_STATUSES = 'GET_CANDIDATE_STATUSES',
  GET_VACANCY_STATUSES = 'GET_VACANCY_STATUSES',
  GET_VACANCY_TARIFFS = 'GET_VACANCY_TARIFFS',
  GET_VACANCY_TARIFFS_HISTORY = 'GET_VACANCY_TARIFFS_HISTORY',
  GET_VACANCY_STATUS_HISTORY = 'GET_VACANCY_STATUS_HISTORY',
  GET_VACANCIES_TEMPLATES = 'GET_VACANCIES_TEMPLATES',
  GET_VACANCY_TEMPLATE = 'GET_VACANCY_TEMPLATE',
  GET_AI_CONSTANTS = 'GET_AI_CONSTANTS',
  GET_AI_CONSTANT = 'GET_AI_CONSTANT',
  LIST_USER_AI_MESSAGES = 'LIST_USER_AI_MESSAGES',
  LIST_USER_AI_MESSAGES_REFRESH = 'LIST_USER_AI_MESSAGES_REFRESH',
}
